/**
 * ExplainMyStrategySection — the "why" cards.
 *
 * Deterministic rationale generated by ``PlannerService``. No AI.
 * Reads like a marketing director explaining their reasoning to a
 * business owner over a coffee.
 */
import { Card } from "@/shared/ui/card";
import type { StrategyExplanationItem } from "../../types";

export function ExplainMyStrategySection({
  items,
}: {
  items: StrategyExplanationItem[];
}): JSX.Element {
  return (
    <section data-testid="strategy-explain-my-strategy">
      <div className="mb-6">
        <p className="text-xs uppercase tracking-widest text-muted-foreground mb-2">
          Explain My Strategy
        </p>
        <h2 className="text-2xl sm:text-3xl font-semibold tracking-tight">
          Why we chose this
        </h2>
      </div>

      <div className="grid gap-4 sm:grid-cols-2">
        {items.map((item, i) => (
          <Card
            key={i}
            className="p-6"
            data-testid={`explain-item-${i}`}
          >
            <p className="font-semibold mb-2">{item.title}</p>
            <p className="text-sm text-muted-foreground leading-relaxed">
              {item.detail}
            </p>
          </Card>
        ))}
      </div>
    </section>
  );
}
